import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    setTimeout(() => {
      window.location.href = '/admin/login';
    }, 100);
  };

  return (
    <header className="md-appbar">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <NavLink
            to="/admin"
            className="flex items-center group"
          >
            <img
              src="/assets/logo.svg"
              alt="Research Clever"
              className="h-10 w-auto transition-all duration-200 group-hover:opacity-80"
            />
          </NavLink>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {[
              { to: '/admin/projects', label: 'Projects' },
              { to: '/admin/suppliers', label: 'Suppliers' },
              { to: '/admin/reports', label: 'Reports' },
              { to: '/admin/failed-attempts', label: 'Failed Attempts' },
            ].map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `md-chip ${isActive ? 'active' : ''}`
                }
              >
                {label}
              </NavLink>
            ))}
            {(user?.role === 'admin' || user?.role === 'super_admin') && (
              <>
                <NavLink
                  to="/admin/users"
                  className={({ isActive }) =>
                    `md-chip ${isActive ? 'active' : ''}`
                  }
                >
                  Users
                </NavLink>
                <NavLink
                  to="/admin/quality-questions"
                  className={({ isActive }) =>
                    `md-chip ${isActive ? 'active' : ''}`
                  }
                >
                  Quality Questions
                </NavLink>
              </>
            )}
          </nav>

          {/* User Actions */}
          <div className="flex items-center gap-3">
            <div className="hidden sm:block text-right">
              <p className="text-sm font-bold text-[#1A1F2B] leading-tight">
                {user?.email?.split('@')[0]}
              </p>
              <p className="text-xs text-[#9CA3AF] capitalize leading-tight">
                {user?.role?.replace('_', ' ')}
              </p>
            </div>
            <div className="w-px h-8 bg-[#E2E5EA] hidden sm:block"></div>
            <NavLink
              to="/admin/account-security"
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors duration-200 px-3 py-1.5 rounded-lg ${
                  isActive
                    ? 'text-[#18A5F9] bg-[#E8F4FD]'
                    : 'text-[#6B7280] hover:text-[#18A5F9] hover:bg-[#E8F4FD]'
                }`
              }
            >
              Security
            </NavLink>
            <button
              onClick={handleLogout}
              className="text-sm font-semibold text-[#6B7280] hover:text-[#EF4444] transition-colors duration-200 px-3 py-1.5 rounded-lg hover:bg-red-50"
            >
              Log Out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
